export default __webpack_public_path__ + "static/media/d3js-icon.3693afdf.svg";